import { useInstallerContext } from '../context/InstallerContext';
import { getInstallLink } from '../services/apis';
import { getVersionToInstall } from '../selectors/appForInstallation';
import { usePanorama } from '../context/PanoramaContext';
export const useProvisionApis = () => {
  const {
    appId,
    httpClient,
    version,
    shareUrlId,
    versionOverrideId,
    preInstallationData: {
      appForInstallation,
      authorizationHeader
    }
  } = useInstallerContext();
  const {
    startTransaction,
    finishTransaction
  } = usePanorama();
  const shouldAddOverrideId = version === 'dev' && versionOverrideId;
  const installWithShareUrlId = async () => {
    startTransaction('install-from-share-url', {
      version,
      ...(shareUrlId && {
        shareUrlId
      }),
      ...(versionOverrideId && {
        versionOverrideId
      })
    });
    const response = await httpClient.post(getInstallLink({
      isShareUrl: true
    }), {
      shareUrlId,
      version: getVersionToInstall(appForInstallation, version),
      ...(shouldAddOverrideId && {
        devVersion: {
          overrideId: versionOverrideId
        }
      })
    }, {
      headers: {
        authorization: authorizationHeader
      }
    });
    finishTransaction('install-from-share-url', {
      requestId: response.requestId
    });
    return response;
  };
  const installWithAppId = async oauth2 => {
    startTransaction('bulk-install', {
      version
    });
    const response = await httpClient.post(getInstallLink(), {
      apps: [{
        id: appId,
        version: getVersionToInstall(appForInstallation, version),
        ...oauth2,
        ...(shouldAddOverrideId && {
          // todo sled test when create dev sites is fixed
          devVersion: {
            overrideId: versionOverrideId
          }
        })
      }]
    }, {
      headers: {
        authorization: authorizationHeader
      }
    });
    finishTransaction('bulk-install', {
      requestId: response.requestId
    });
    return response;
  };
  return {
    installWithAppId,
    installWithShareUrlId
  };
};
//# sourceMappingURL=useProvisionApis.js.map